import { useEffect, useState } from 'react';

const ICON_FONT = '24px "Material Symbols Rounded"';

/**
 * Indica se a fonte de ícones (Material Symbols Rounded) já foi carregada.
 * Enquanto ela não está pronta, os `<span>` de ícones renderizam o nome cru
 * do ícone (ex.: "ads_click"), então usamos esse estado para exibir um
 * skeleton no lugar.
 */
export function useIconFontReady(): boolean {
  const [isReady, setIsReady] = useState<boolean>(() => {
    if (typeof document === 'undefined' || !('fonts' in document)) {
      return true;
    }
    return document.fonts.check(ICON_FONT);
  });

  useEffect(() => {
    if (isReady) {
      return;
    }

    if (typeof document === 'undefined' || !('fonts' in document)) {
      setIsReady(true);
      return;
    }

    let isMounted = true;

    document.fonts
      .load(ICON_FONT)
      .then(() => {
        if (isMounted) {
          setIsReady(true);
        }
      })
      .catch(() => {
        if (isMounted) {
          setIsReady(true);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [isReady]);

  return isReady;
}
